// Money/rate helpers for the withholding tax screens (docs/WHT_IMPLEMENTATION.md).
// The server stores integer centavos and integer basis points and computes the
// tax withheld itself; these exist so the grid can SHOW the same figure live.

/** Pesos (number or numeric string) → integer centavos, rounded to the centavo. */
export function pesosToCentavos(pesos) {
  const n = Number(String(pesos ?? '').replace(/,/g, ''));
  return Number.isFinite(n) ? Math.round(n * 100) : NaN;
}

/** Percent (e.g. 5, '0.5', '12.75') → integer basis points; NaN when not a number. */
export function percentToBasisPoints(percent) {
  if (percent === '' || percent === null || percent === undefined) return NaN;
  const n = Number(String(percent).trim());
  return Number.isFinite(n) ? Math.round(n * 100) : NaN;
}

export const basisPointsToPercent = (bp) => (Number.isFinite(bp) ? bp / 100 : '');

/**
 * Tax withheld in centavos — half-up on the centavo. Same formula as the server
 * (backend/services/wht/ewtRecord.service.js computeTaxWithheldCentavos), done
 * in BigInt so it is exact. Returns null when an input is missing/invalid.
 */
export function computeTaxWithheldCentavos(baseCentavos, rateBasisPoints) {
  if (!Number.isSafeInteger(baseCentavos) || baseCentavos < 0) return null;
  if (!Number.isInteger(rateBasisPoints) || rateBasisPoints < 0 || rateBasisPoints > 10000) return null;
  const n = BigInt(baseCentavos) * BigInt(rateBasisPoints) + BigInt(5000);
  return Number(n / BigInt(10000));
}

const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** 123457 → "1,234.57"; null/NaN → "—". */
export const formatCentavos = (c) => (Number.isFinite(c) ? formatter.format(c / 100) : '—');

/** 500 → "5.00%". */
export const formatRate = (bp) => (Number.isFinite(bp) ? `${(bp / 100).toFixed(2)}%` : '—');
